<template>
  <div>
    <!-- 文档挂载容器 -->
    <div id="wps-container" style="width: 100%; height: 100vh"></div>
  </div>
</template>

<script>
import WebOfficeSDK from './web-office-sdk-solution-v2.0.7.es.js'
export default {
  name: 'Demo',
  data() {
    return {
      instance: null,
      fileId:'',
      reportFileName:'',
      enterTime:'',
      isShare: false
    }
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    this.isShare = params.get('share') || false
    this.fileId = params.get('fileId')
    this.reportFileName = params.get('reportFileName')
    this.enterTime = params.get('enterTime')
    // 设置微信分享
    this.setWxShare()

    this.$nextTick(() => {
      // 微信浏览器需要更长的延迟
      const isWeiXin = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
      this.isShare =  this.isShare  ||  !isWeiXin   // 分享和不在微信环境中
      const delay = isWeiXin ? 500 : 100

      setTimeout(() => {
        this.init()
      }, delay)
    })
  },
  beforeDestroy() {
    // 清理实例
    if (this.instance) {
      try {
        this.instance.destroy()
      } catch (e) {
        console.error('销毁实例失败:', e)
      }
    }
  },
  methods: {
    // 测试appId : 'SX20250427GFXKNE'    正式appID ：'AK20250829JNUMFB'
    async init() {
        this.instance = WebOfficeSDK.init({
          officeType: WebOfficeSDK.OfficeType.Writer,
          appId: 'SX20250427GFXKNE',
          fileId: this.fileId,
          customArgs:{isShare:this.isShare},
          token:'eXFtcy13ZWNoYXQ=',
          mount: document.getElementById('wps-container'),
          commonOptions: {
            isShowTopArea: true, // 隐藏顶部区域
            isShowHeader: false, // 隐藏头部区域
            isBrowserViewFullscreen: true // 支持全屏
          },
          // 微信浏览器特殊配置
          attrAllow: 'clipboard-read; clipboard-write; fullscreen',
          isListenResize: true, // 监听窗口大小变化
        })
      // 等待实例准备就绪
      await this.instance.ready()
    },
    // 设置微信分享
    setWxShare() {
      const imgUrl = 'http://www.ewrwefg.com/nas/img/share.png'
      // 自定义微信分享配置
      this.customWxShare(this.reportFileName, this.enterTime, imgUrl)
    },

    // 自定义微信分享函数
    customWxShare(title, desc, imgUrl) {
      const { getWxconfig } = require('@/api/public.js')
      const wx = require('weixin-js-sdk')

      getWxconfig({url:encodeURIComponent(window.location.href.split('#')[0])}).then((res) => {
        // 微信支付使用
        localStorage.setItem('wxdata',JSON.stringify(res.data));

        wx.config({
          debug: false,
          appId: res.data.appId,
          timestamp: res.data.timestamp,
          nonceStr: res.data.nonceStr,
          signature: res.data.signature,
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'hideMenuItems',
            'onMenuShareQZone'
          ]
        })

        wx.ready(() => {
          wx.hideMenuItems({
            menuList: [
              "menuItem:copyUrl",
              "menuItem:originPage",
              "menuItem:openWithQQBrowser",
              "menuItem:openWithSafari"
            ]
          });

          let urlStr = window.location.href.split('#')[0]
          if(urlStr.indexOf('&isAuthorised=1') == -1){
            urlStr = urlStr+'&isAuthorised=1'
          }
          urlStr += "&share=true"

          if(wx.updateAppMessageShareData){
            wx.updateAppMessageShareData({
              title: title,
              desc: desc,
              link: urlStr,
              imgUrl: imgUrl,
              success: function () {
                console.log('分享设置成功')
              }
            })
          }else{
            wx.onMenuShareAppMessage({
              title: title,
              desc: desc,
              link: urlStr,
              imgUrl: imgUrl,
              type: '',
              dataUrl: '',
              success: function () {
                console.log('分享成功')
              }
            });
          }

          if(wx.updateTimelineShareData) {
            wx.updateTimelineShareData({
              title: title,
              link: urlStr,
              imgUrl: imgUrl,
              success: function () {
                console.log('朋友圈分享设置成功')
              }
            })
          }else{
            wx.onMenuShareTimeline({
              title: title,
              link: urlStr,
              imgUrl: imgUrl,
              success: function () {
                console.log('朋友圈分享成功')
              }
            })
          }
        });
      });
    }
  }
}
</script>


<style scoped>
  @import url("./report.css");
</style>
